import { render, staticRenderFns } from "./circulars.vue?vue&type=template&id=d3a4fe70&scoped=true&"
import script from "./circulars.vue?vue&type=script&lang=js&"
export * from "./circulars.vue?vue&type=script&lang=js&"
import style0 from "./circulars.vue?vue&type=style&index=0&id=d3a4fe70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a4fe70",
  null
  
)

export default component.exports